module.exports = __webpack_public_path__ + "img/3.a4d59d7c.jpg";